import { inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, filter, map, Observable } from 'rxjs';
import { RouteBreadcrumbs, RouteTitleModel } from '../interfaces/route-title';

@Injectable({
  providedIn: 'root',
})
export class RouteTitleService {
  public get routeTitle$(): Observable<RouteTitleModel | null> {
    return this.routeTitleSubject.asObservable();
  }

  private routeTitleSubject = new BehaviorSubject<RouteTitleModel | null>(null);

  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  constructor() {
    this.router.events
      .pipe(
        takeUntilDestroyed(),
        filter((event) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((route: ActivatedRoute) => {
          while (route.firstChild) {
            route = route.firstChild;
          }

          return route;
        }),
        map((route: ActivatedRoute) => this.buildRouteTitleModel(route)),
      )
      .subscribe((routeTitleModel: RouteTitleModel | null) => {
        this.routeTitleSubject.next(routeTitleModel);
      });
  }

  private buildRouteTitleModel(route: ActivatedRoute): RouteTitleModel | null {
    const breadcrumbs = route.snapshot.data?.['breadcrumbs'] as RouteBreadcrumbs;

    if (breadcrumbs) {
      return { breadcrumbs: breadcrumbs };
    } else {
      return null;
    }
  }
}
